import { render, staticRenderFns } from "./select-user.vue?vue&type=template&id=b9c8acdc&scoped=true&"
import script from "./select-user.vue?vue&type=script&lang=js&"
export * from "./select-user.vue?vue&type=script&lang=js&"
import style0 from "./select-user.vue?vue&type=style&index=0&id=b9c8acdc&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c8acdc",
  null
  
)

export default component.exports